var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    {
      staticClass: "fc-day-grid-event fc-h-event fc-event fc-start fc-end",
      class: [_vm.eventStatusClass],
      attrs: { to: _vm.eventRouterLink, title: _vm.eventDescription },
      nativeOn: {
        click: function ($event) {
          return _vm.handleEventClickCallback.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "fc-content" }, [
        _c("span", { staticClass: "fc-time" }, [
          _vm._v(_vm._s(_vm.eventStartTime)),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "fc-title" }, [
          _vm._v(_vm._s(_vm.eventDescription)),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }